import React from 'react';
import { BsJustify } from 'react-icons/bs';
import { image } from "../../src/common/Theme";
import { useLocation, useNavigate } from 'react-router-dom';
import { useNotifications } from '../context/NotificationContext';

function Header({ OpenSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { unreadCount, markAllAsRead } = useNotifications();

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  // console.log(userInfo)


  let pageTitle = '';
  switch (location.pathname) {
    case '/dashboard':
      pageTitle = 'Dashboard';
      break;
    case '/users':
      pageTitle = 'User Management';
      break;
    case '/bookings':
      pageTitle = 'Booking';
      break;
    case '/payments':
      pageTitle = 'Payments';
      break;
    case '/policies':
      pageTitle = 'Policy';
      break;
    case '/reports':
      pageTitle = 'Policy';
      break;
    case '/vendors':
      pageTitle = 'Vendor Management';
      break;
    case '/agents':
      pageTitle = 'Agent Management';
      break;
    case '/parking-slots':
      pageTitle = 'Parking Slots';
      break;
    case '/rate-chart':
      pageTitle = 'Rate Chart';
      break;
    case '/notifications':
      pageTitle = 'Notification';
      break;

    case '/car-movements':
      pageTitle = 'Car Movements';
      break;

    case '/revenue-report':
      pageTitle = 'Revenue Report';
      break;

    case '/add-booking':
      pageTitle = 'Booking';
      break;
    case '/customer-booking':
      pageTitle = 'Booking';
      break;
    case '/booking-details':
      pageTitle = 'Booking';
      break;
    case '/booking-receipts':
      pageTitle = 'Booking';
      break;

    case '/profile':
      pageTitle = 'Profile';
      break;
    case '/change-password':
      pageTitle = 'Change Password';
      break;
    default:
      pageTitle = '';
  }

  return (
    <header className='header'>
      <button className='menu-icon' type="button" onClick={OpenSidebar} aria-label="Open navigation">
        <BsJustify className='icon' />
      </button>
      <div className='header-left'>
        <h3>{pageTitle}</h3>
        <p className="header-subtitle">Prime Park admin workspace</p>
      </div>
      <div className='header-right'>
        <div className='user-details'>
          <img src={image.userimage} alt="User avatar" />
          <div>
            <strong>{userInfo?.firstName || "Admin"}</strong>
            <span>Control center</span>
          </div>
        </div>
        <button
          type="button"
          className='header-notification'
          aria-label="Notifications"
          onClick={async () => {
            await markAllAsRead();
            navigate('/notifications');
          }}
        >
          <img src={image.notificationbell} alt="Notifications" />
          {unreadCount > 0 && (
            <span className='header-notification-count'>
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}

export default Header;
